import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const BarChartSection = ({
  configs,
  selectedConfigId,
  setSelectedConfigId,
  chartData,
  onAdd,
  onDelete, // ✅ NEW
}) => {
  const selectedConfig = configs.find((c) => c._id === selectedConfigId);

  return (
    <div className="rounded-2xl bg-white/80 border shadow p-4 w-full">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="text-sm font-semibold text-slate-800">
            {selectedConfig?.heading || "Bar Chart"}
          </h3>
        </div>

        <div className="flex items-center gap-2">
          {selectedConfigId && (
            <button
              type="button"
              onClick={onDelete}
              className="rounded-full border border-red-200 bg-red-50 px-3 py-1 text-xs font-medium text-red-600 hover:bg-red-100"
            >
              🗑 Delete
            </button>
          )}

          <button
            onClick={onAdd}
            className="rounded-full border border-sky-300 bg-white px-3 py-1 text-xs text-sky-600"
          >
            ＋ Add
          </button>
        </div>
      </div>

      {configs.length > 1 && (
        <div className="mt-2 flex justify-end">
          <select
            className="rounded-full border px-2 py-1 text-xs"
            value={selectedConfigId}
            onChange={(e) => setSelectedConfigId(e.target.value)}
          >
            {configs.map((cfg) => (
              <option key={cfg._id} value={cfg._id}>
                {cfg.heading}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="h-48 mt-3">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="label"
              // tick={{
              //   fontSize: 10,
              //   angle: -30,
              //   textAnchor: "end",
              //   fontSize: 11,
              //   fill: "#333",
              // }}
              interval={3}
            />
            <YAxis
              tick={{ fontSize: 10 }}
              label={{
                value: "Count",
                angle: -90,
                position: "insideLeft",
                style: { textAnchor: "middle", fontSize: 11 },
              }}
            />
            <Tooltip />
            <Bar dataKey="value" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default BarChartSection;
